// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Belt__Belt_Option from "melange.belt/belt_Option.js";
import * as Caml_option from "melange.js/caml_option.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib__List from "melange/list.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function ESFCarousel(Props) {
  const match = React.useState(function () {
    return 0;
  });
  const setIdx = match[1];
  const idx = match[0];
  const match$1 = React.useState(function () {
    
  });
  const setInt = match$1[1];
  const interval = match$1[0];
  const match$2 = React.useState(function () {
    
  });
  const setRemove = match$2[1];
  const remove = match$2[0];
  const slideRef = React.useRef(null);
  const participants_0 = {
    image: StaticAsset.src("/static/images/manufacturer.png"),
    name: "Производитель",
    text: "Создавайте СНТ на произведенные товары."
  };
  const participants_1 = {
    hd: {
      image: StaticAsset.src("/static/images/seller.png"),
      name: "Продавец",
      text: "Просматривайте входящие СНТ и принимайте или отклоняйте их, выставляйте СНТ покупателям."
    },
    tl: {
      hd: {
        image: StaticAsset.src("/static/images/consumer.png"),
        name: "Потребитель",
        text: "Просто учитывайте входящие СНТ в кабинете."
      },
      tl: /* [] */ 0
    }
  };
  const participants = {
    hd: participants_0,
    tl: participants_1
  };
  const clean = function (param) {
    if (interval !== undefined) {
      clearInterval(Caml_option.valFromOption(interval));
    }
    if (remove !== undefined) {
      clearTimeout(Caml_option.valFromOption(remove));
      return;
    }
    
  };
  React.useEffect((function () {
    const cardElement = slideRef.current;
    Belt__Belt_Option.map((cardElement == null) ? undefined : Caml_option.some(cardElement), (function (el) {
      el.classList.remove("filter-blur-5");
      const remove = setTimeout((function (param) {
        el.classList.add("filter-blur-5");
      }), 4800);
      Curry._1(setRemove, (function (param) {
        return Caml_option.some(remove);
      }));
      return function (param) {
        clearTimeout(remove);
      };
    }));
    const intrvl = setInterval((function (param) {
      const nextIdx = idx + 1 | 0;
      if (nextIdx < Stdlib__List.length(participants)) {
        return Curry._1(setIdx, (function (param) {
          return nextIdx;
        }));
      } else {
        return Curry._1(setIdx, (function (param) {
          return 0;
        }));
      }
    }), 5000);
    Curry._1(setInt, (function (param) {
      return Caml_option.some(intrvl);
    }));
    return (function (param) {
      clearInterval(intrvl);
    });
  }), [idx]);
  const participant = Stdlib__List.nth(participants, idx);
  return JsxRuntime.jsxs(React.Fragment, {
    children: [
      JsxRuntime.jsxs("div", {
        ref: slideRef,
        children: [
          JsxRuntime.jsx("img", {
            className: "flex m-auto w-60 h-60",
            alt: "buhta",
            src: participant.image
          }),
          JsxRuntime.jsx("h4", {
            children: participant.name,
            className: "h4 text-center text-black-landing mt-8"
          }),
          JsxRuntime.jsx("p", {
            children: participant.text,
            className: "paragraph text-center text-gray-landing mt-2 h-18"
          })
        ],
        className: "transition duration-150 ease-in px-12 sm:px-48"
      }),
      JsxRuntime.jsx("div", {
        children: Belt__Belt_List.toArray(Stdlib__List.mapi((function (i, param) {
          const Key = "carousel_step_" + String(i);
          return JsxRuntime.jsx("div", {
            children: JsxRuntime.jsx("img", {
              className: i === idx ? "opacity-100" : "opacity-24",
              src: StaticAsset.src("/static/icons/step.svg")
            }),
            className: "ml-2 first:ml-0 cursor-pointer py-4",
            onClick: (function (param) {
              clean(undefined);
              Curry._1(setIdx, (function (param) {
                return i;
              }));
            })
          }, Key);
        }), participants)),
        className: "flex justify-center mt-4"
      })
    ]
  });
}

const make = ESFCarousel;

export {
  make,
}
/* react Not a pure module */
